exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-info h3[data-v-3b37965d]{margin-bottom:0}.note-info img[data-v-3b37965d]{vertical-align:middle}a svg[data-v-3b37965d]{fill:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b37965d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotebookMap.vue
// module id = 189
// module chunks = 0